module.exports = __webpack_public_path__ + "static/media/img81_R.2a3f7006.jpg";